import { EventName } from '@lit/react';
import { BlocksModal } from 'blocks-nextjs/blocks-web-components/components/modal/modal';
import { BlocksCancelEvent, BlocksCloseEvent, BlocksOpenEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatModal = createComponent({
  react: React,
  tagName: 'cat-modal',
  elementClass: BlocksModal,
  events: {
    onBlModalClose: 'bl-modal-close' as EventName<BlocksCloseEvent>,
    onBlModalCancel: 'bl-modal-cancel' as EventName<BlocksCancelEvent>,
    onBlModalOpen: 'bl-modal-open' as EventName<BlocksOpenEvent>
  }
});
